/*
 * custom-perso-subscription.js  (v2)  —  les Enfants Sauvages
 * --------------------------------------------------------------------------
 * Pont d'abonnement : widget Appstle  <->  formulaire produit (Prestige v4)
 *
 * PROBLEME CORRIGE
 *   Le widget Appstle place ses radios name="selling_plan" EN DEHORS du
 *   <form action="/cart/add"> du theme v4 (<product-form>). Or <product-form>
 *   ne serialise que les champs SITUES DANS le formulaire -> le plan n'est
 *   jamais envoye -> abonnement ajoute au prix plein (35 EUR au lieu de 34 EUR).
 *
 * CORRECTIF (mecanisme OFFICIEL Shopify : input name="selling_plan" DANS le
 *   formulaire, mis a jour en JS). Ce script maintient un input cache
 *   name="selling_plan" UNIQUEMENT dans le formulaire associe au widget,
 *   synchronise avec le plan choisi (vide = achat unique). Il le (re)pose
 *   juste avant l'envoi -> reste correct apres un re-render (variante).
 *
 * v2 : le pont est SCOPE au seul formulaire du widget (remontee DOM depuis le
 *   widget). Les formulaires "Achetez le avec" / recommandations ne sont JAMAIS
 *   touches (sinon un cross-sell heriterait a tort du plan du produit principal).
 *
 * SECURITE / PERF
 *   - selling_plan = identifiant PUBLIC (deja dans le JSON produit et l'URL).
 *   - Prix applique COTE SERVEUR par Shopify selon la pricing policy du plan :
 *     impossible de fabriquer une fausse remise via cet input.
 *   - Aucun cookie, aucune donnee perso, aucun eval, aucun appel reseau.
 *   - ~1.5 Ko, charge en defer, 3 ecouteurs delegues : impact nul.
 * --------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var FLAG = 'data-les-sp-bridge'; // marque notre input cache

  // Elements de plan du widget Appstle (hors formulaire), hors notre input cache.
  function widgetPlanEls() {
    var all = document.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].hasAttribute(FLAG)) out.push(all[i]);
    }
    return out;
  }

  // Valeur du plan choisi.  '' = achat unique (aucun plan)  |  null = pas de widget sur la page.
  function selectedPlan() {
    var els = widgetPlanEls();
    if (!els.length) {
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('selling_plan')) return u.searchParams.get('selling_plan') || '';
      } catch (e) {}
      return null;
    }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.tagName === 'SELECT') return el.value || '';
      if (el.type === 'radio') { if (el.checked) return el.value || ''; }
      else if (el.value) return el.value;
    }
    return '';
  }

  // Formulaire d'ajout au panier ASSOCIE au widget : on remonte depuis le widget
  // jusqu'au premier ancetre qui contient un formulaire /cart/add (= colonne produit).
  // Les cross-sell sont dans d'autres branches, donc jamais retournes ici.
  function widgetForm() {
    var els = widgetPlanEls();
    for (var i = 0; i < els.length; i++) {
      var node = els[i];
      while (node && node.parentElement) {
        node = node.parentElement;
        var idInput = node.querySelector('form[action*="/cart/add"] [name="id"]');
        if (idInput) return idInput.closest('form[action*="/cart/add"]');
      }
    }
    return null;
  }

  // Pose/maj l'input cache UNIQUEMENT dans le formulaire du widget.
  function sync() {
    try {
      var plan = selectedPlan();
      if (plan === null) return;        // pas d'abonnement : on ne touche a rien
      var form = widgetForm();
      if (!form) return;                // formulaire principal non identifie
      var hidden = form.querySelector('input[name="selling_plan"][' + FLAG + ']');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.setAttribute(FLAG, '');
        form.appendChild(hidden);
      }
      hidden.value = plan;
    } catch (e) {}
  }

  // 1) Changement de plan (radios Appstle)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'selling_plan' && !t.hasAttribute(FLAG)) sync();
  }, true);

  // 2) Avant l'envoi d'un formulaire d'ajout (capture sur document)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) sync();
  }, true);

  // 3) Filet : clic sur un bouton d'ajout (capture)
  document.addEventListener('click', function (e) {
    var n = e.target;
    var b = n && n.closest ? n.closest('[type="submit"], button[name="add"]') : null;
    if (b && b.closest('form[action*="/cart/add"]')) sync();
  }, true);

  // 4) Etat initial (deep-link ?selling_plan=, ou plan deja coche)
  function init() { sync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
